var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "table" }, [
      _c("div", { staticClass: "table-header-title table-header-container" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("standaloneWorkPermit.management.title")) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-header-popover table-header-container" },
        [
          _c("Popover", {
            attrs: { text: _vm.$t("standaloneWorkPermit.management.popover") },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "table-container" }, [
        _c(
          "table",
          [
            _c("thead", [
              _c(
                "tr",
                [
                  _vm._l(_vm.tableElements, function (ref, index) {
                    var title = ref.title
                    var mandatory = ref.mandatory
                    return _c(
                      "th",
                      {
                        key: index,
                        class: {
                          "required-flag":
                            mandatory && _vm.isEditing && _vm.hasSWPRight,
                        },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t(title)) +
                            "\n            "
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("th"),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _vm.isEditing && _vm.hasSWPRight
              ? _c("Edit")
              : _c("Display", { attrs: { canInvite: _vm.hasSWPRight } }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.hasSWPRight && _vm.isEditing
        ? _c(
            "i",
            { staticClass: "addBtn", on: { click: _vm.addNewContractor } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("standaloneWorkPermit.management.addContractor")
                  ) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }